import { Habit } from './types';
import * as icons from './iconComponents';

// 图标分类定义
export const ICON_CATEGORIES = [
  {
    id: 'common',
    name: '常用',
    icons: [
      { name: 'Sun', component: icons.Sun, color: '#F59E0B' },
      { name: 'Moon', component: icons.Moon, color: '#6366F1' },
      { name: 'Star', component: icons.Star, color: '#FBBF24' },
      { name: 'Heart', component: icons.Heart, color: '#EF4444' },
      { name: 'Zap', component: icons.Zap, color: '#FBBF24' },
      { name: 'Target', component: icons.Target, color: '#EF4444' },
      { name: 'Trophy', component: icons.Trophy, color: '#F59E0B' },
      { name: 'Award', component: icons.Award, color: '#8B5CF6' },
      { name: 'Gift', component: icons.Gift, color: '#EC4899' },
      { name: 'Bell', component: icons.Bell, color: '#F59E0B' },
      { name: 'Settings', component: icons.Settings, color: '#6B7280' },
      { name: 'User', component: icons.User, color: '#3B82F6' },
      { name: 'Users', component: icons.Users, color: '#8B5CF6' },
      { name: 'Home', component: icons.Home, color: '#10B981' },
      { name: 'Calendar', component: icons.Calendar, color: '#3B82F6' },
      { name: 'Clock', component: icons.Clock, color: '#6B7280' },
      { name: 'Timer', component: icons.Timer, color: '#F59E0B' },
      { name: 'AlarmClock', component: icons.AlarmClock, color: '#EF4444' },
    ]
  },
  {
    id: 'study',
    name: '学习',
    icons: [
      { name: 'BookOpen', component: icons.BookOpen, color: '#3B82F6' },
      { name: 'Book', component: icons.Book, color: '#8B5CF6' },
      { name: 'GraduationCap', component: icons.GraduationCap, color: '#1D4ED8' },
      { name: 'PenTool', component: icons.PenTool, color: '#EC4899' },
      { name: 'Pencil', component: icons.Pencil, color: '#F59E0B' },
      { name: 'FileText', component: icons.FileText, color: '#6B7280' },
      { name: 'ClipboardList', component: icons.ClipboardList, color: '#6366F1' },
      { name: 'Glasses', component: icons.Glasses, color: '#6B7280' },
      { name: 'Lightbulb', component: icons.Lightbulb, color: '#FBBF24' },
      { name: 'Brain', component: icons.Brain, color: '#EC4899' },
      { name: 'Calculator', component: icons.Calculator, color: '#10B981' },
      { name: 'Languages', component: icons.Languages, color: '#3B82F6' },
      { name: 'Library', component: icons.Library, color: '#8B5CF6' },
      { name: 'Newspaper', component: icons.Newspaper, color: '#6B7280' },
    ]
  },
  {
    id: 'sports',
    name: '运动',
    icons: [
      { name: 'Dumbbell', component: icons.Dumbbell, color: '#EF4444' },
      { name: 'Footprints', component: icons.Footprints, color: '#10B981' },
      { name: 'Activity', component: icons.Activity, color: '#EF4444' },
      { name: 'Bike', component: icons.Bike, color: '#6366F1' },
      { name: 'Waves', component: icons.Waves, color: '#06B6D4' },
      { name: 'Mountain', component: icons.Mountain, color: '#10B981' },
      { name: 'Tent', component: icons.Tent, color: '#F59E0B' },
      { name: 'Flame', component: icons.Flame, color: '#F97316' },
      { name: 'Medal', component: icons.Medal, color: '#FBBF24' },
    ]
  },
];

// 兼容旧版本的扁平化图标列表
export const AVAILABLE_ICONS = ICON_CATEGORIES.flatMap(cat => cat.icons);

export const APP_NAME = "HabitSync";

export const DEFAULT_HABITS: Habit[] = [
  {
    id: '1',
    memberId: 'default',
    title: '早起',
    description: '早晨 7:00 前起床',
    icon: 'Sun',
    color: 'bg-orange-500',
    frequency: 'daily',
    targetDays: [0, 1, 2, 3, 4, 5, 6],
    createdAt: new Date().toISOString(),
    streak: 3,
    completedDates: [],
    milestones: [
        { target: 7, reward: '奖励自己一顿丰盛早餐' },
        { target: 21, reward: '买一本新书' }
    ],
    logs: []
  },
  {
    id: '2',
    memberId: 'default',
    title: '喝水 2L',
    description: '保持身体水分充足',
    icon: 'Droplets',
    color: 'bg-blue-400',
    frequency: 'daily',
    targetDays: [0, 1, 2, 3, 4, 5, 6],
    createdAt: new Date().toISOString(),
    streak: 0,
    completedDates: [],
    milestones: [],
    logs: []
  },
  {
    id: '3',
    memberId: 'default',
    title: '冥想 10分钟',
    description: '放空大脑，专注呼吸',
    icon: 'Leaf',
    color: 'bg-emerald-500',
    frequency: 'daily',
    targetDays: [0, 1, 2, 3, 4, 5, 6],
    createdAt: new Date().toISOString(),
    streak: 0,
    completedDates: [],
    milestones: [
        { target: 30, reward: 'SPA体验一次' }
    ],
    logs: []
  },
  {
    id: '4',
    memberId: 'default',
    title: '跑步 3公里',
    description: '有氧运动',
    icon: 'Footprints',
    color: 'bg-indigo-500',
    frequency: 'weekly',
    targetDays: [1, 3, 5, 0], 
    createdAt: new Date().toISOString(),
    streak: 0,
    completedDates: [],
    milestones: [
        { target: 10, reward: '购买新运动袜' },
        { target: 30, reward: '购买新跑鞋' }
    ],
    logs: []
  }
];

export const COLORS = [
  'bg-red-500',
  'bg-orange-500',
  'bg-amber-500',
  'bg-green-500',
  'bg-emerald-500',
  'bg-teal-500',
  'bg-cyan-500',
  'bg-blue-500',
  'bg-indigo-500',
  'bg-violet-500',
  'bg-purple-500',
  'bg-fuchsia-500',
  'bg-pink-500',
  'bg-rose-500',
  'bg-slate-500',
];
